/*
  this file is a mock of the OG sofe package.
  with the new systemjs setup, there's not really a need for sofe to exist
  but until we can clean it out of our dependencies, we need this file
*/
export { getPublicPath as getServiceUrl } from "./sofe-common";
export function getAllManifests() {
  return Promise.resolve({ flat: {} });
}
export function isOverride() {
  return false;
}
export function InvalidServiceName() {}
InvalidServiceName.prototype = Object.create(Error.prototype);
